import styled from "styled-components"

export const RelatedContactsList = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`
export const RelatedContactsItem = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(36, 85, 239, 0.1);
    border-radius: 4px;
    padding: 5px 10px;
`

export const RelatedContactsItemText = styled.div`
  color: #2455ef;
  display: flex;
  align-items: center;
  gap: 5px;
`

export const RelatedContactsItemTextStrong = styled.strong`
  font-weight: bold;
`

export const RelatedContactsItemLink = styled.span`
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
`
export const RelatedContactsItemDelete= styled.div`
  cursor: pointer;
`